import { useState, useCallback } from 'react';
import { roleService } from '@/services/api';
import type { Role, RoleCreatePayload, RoleUpdatePayload } from '@/common-types';
import type { UseRolesReturn } from '@/types/application/common/hooks/use-roles';

export function useRoles(): UseRolesReturn {
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await roleService.listRoles();
      setRoles(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load roles');
    } finally {
      setLoading(false);
    }
  }, []);

  const createRole = useCallback(async (payload: RoleCreatePayload) => {
    await roleService.createRole(payload);
    await refresh();
  }, [refresh]);

  const updateRole = useCallback(async (roleId: string, payload: RoleUpdatePayload) => {
    await roleService.updateRole(roleId, payload);
    await refresh();
  }, [refresh]);

  const deleteRole = useCallback(async (roleId: string) => {
    await roleService.deleteRole(roleId);
    await refresh();
  }, [refresh]);

  return { roles, loading, error, refresh, createRole, updateRole, deleteRole };
}

export default useRoles;




